<ng-template #detailsFieldsEmpty>
  @if (emptyText) {
    <p
      class="break-all px-5 pb-3.5 py-2"
      [ngClass]="emptyClass"
      data-testid="details-fields-empty">
      {{ emptyText }}
    </p>
  }
</ng-template>

@switch (view) {
  @case ('personal') {
    @if (!hasPersonal) {
      <ng-container *ngTemplateOutlet="detailsFieldsEmpty" />
    } @else {
      <div
        class="flex flex-col gap-3 px-5 pb-3.5"
        data-testid="details-fields-personal">
        @if (personal.name || personal.deceased) {
          <div class="grid grid-cols-[50%_50%]">
            @if (personal.name) {
              <div data-testid="details-fields-personal-name">
                <div [ngClass]="labelClass">{{ 'Name' | translate }}</div>
                <div class="break-all" [ngClass]="detailClass">{{ personal.name }}</div>
              </div>
            }
            @if (isDeceased) {
              <div
                class="inline-flex w-fit items-center self-end rounded-md px-1.5 py-0.5"
                data-testid="details-fields-personal-deceased"
                [ngClass]="deceasedClass">
                {{ personal.deceased }}
              </div>
            }
          </div>
        }
        @if (personal.dateOfBirth || personal.age || personal.sex) {
          <div class="grid grid-cols-[50%_25%_25%]">
            @if (personal.dateOfBirth) {
              <div data-testid="details-fields-personal-dob">
                <div [ngClass]="labelClass">{{ 'Date of birth' | translate }}</div>
                <div [ngClass]="detailClass">{{ personal.dateOfBirth }}</div>
              </div>
            }
            @if (personal.age) {
              <div data-testid="details-fields-personal-age">
                <div [ngClass]="labelClass">{{ 'Age' | translate }}</div>
                <div [ngClass]="detailClass">{{ personal.age }}</div>
              </div>
            }
            @if (personal.sex) {
              <div data-testid="details-fields-personal-sex">
                <div [ngClass]="labelClass">{{ 'Sex' | translate }}</div>
                <div [ngClass]="detailClass">{{ personal.sex }}</div>
              </div>
            }
          </div>
        }
      </div>
    }
  }
  @case ('visit') {
    @if (!hasVisit) {
      <ng-container *ngTemplateOutlet="detailsFieldsEmpty" />
    } @else {
      <div
        class="flex flex-col gap-3 px-5 pb-3.5"
        data-testid="details-fields-visit">
        @if (visit.specialty || visit.location) {
          <div class="grid grid-cols-2">
            @if (visit.specialty) {
              <div data-testid="details-fields-visit-specialty">
                <div [ngClass]="labelClass">{{ 'Speciality' | translate }}</div>
                <div class="break-all" [ngClass]="detailClass">{{ visit.specialty }}</div>
              </div>
            }
            @if (visit.location) {
              <div data-testid="details-fields-visit-location">
                <div [ngClass]="labelClass">{{ 'Location' | translate }}</div>
                <div class="break-all" [ngClass]="detailClass">{{ visit.location }}</div>
              </div>
            }
          </div>
        }
        @if (visit.admitted || visit.discharged) {
          <div class="grid grid-cols-2">
            @if (visit.admitted) {
              <div data-testid="details-fields-visit-admitted">
                <div [ngClass]="labelClass">{{ 'Admitted' | translate }}</div>
                <div [ngClass]="detailClass">{{ visit.admitted }}</div>
              </div>
            }
            @if (visit.discharged) {
              <div data-testid="details-fields-visit-discharged">
                <div [ngClass]="labelClass">{{ 'Discharged' | translate }}</div>
                <div [ngClass]="detailClass">{{ visit.discharged }}</div>
              </div>
            }
          </div>
        }
        @if (visit.consultant || visit.referredBy) {
          <div class="grid grid-cols-2">
            @if (visit.consultant) {
              <div data-testid="details-fields-visit-consultant">
                <div [ngClass]="labelClass">{{ 'Consultant' | translate }}</div>
                <div class="break-all" [ngClass]="detailClass">{{ visit.consultant }}</div>
              </div>
            }
            @if (visit.referredBy) {
              <div data-testid="details-fields-visit-referred-by">
                <div [ngClass]="labelClass">{{ 'Referred by' | translate }}</div>
                <div class="break-all" [ngClass]="detailClass">{{ visit.referredBy }}</div>
              </div>
            }
          </div>
        }
      </div>
    }
  }
}
